// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1GT2t","title":"Info_title__2AMbd","selects":"Info_selects__235SY","requiredAsterisk":"Info_requiredAsterisk__1cX4O"};